module.exports = __webpack_public_path__ + "static/img/sabrinapowell_circle150.373c5ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/sabrinapowell_circle150.png
// module id = oSj6
// module chunks = 0